<script>
import { mapGetters } from 'vuex';
import ResolveAction from '../../buttons/ResolveAction.vue';

export default {
  components: {
    ResolveAction,
  },
  computed: {
    ...mapGetters({ currentChat: 'getSelectedChat' }),
  },
};
</script>

<template>
  <div class="relative flex items-center gap-2 actions--container">
    <ResolveAction
      :conversation-id="currentChat.id"
      :status="currentChat.status"
    />
  </div>
</template>

<style scoped lang="scss">
.more--button {
  @apply items-center flex ml-2 rtl:ml-0 rtl:mr-2;
}

.dropdown-pane {
  @apply -right-2 top-12;
}

.icon {
  @apply mr-1 rtl:mr-0 rtl:ml-1 min-w-[1rem];
}
</style>
